import {
	LanguageCloseButton,
	LanguageHeaderCopy,
	LanguageModalHeader,
	LanguageSubtitle,
	LanguageTitle,
} from '../LanguageSwitcher.styles';

const LanguageSwitcherModalHeader = ({
	title,
	subtitle,
	closeLabel,
	onClose,
}) => (
	<LanguageModalHeader>
		<LanguageHeaderCopy>
			<LanguageTitle>{title}</LanguageTitle>
			<LanguageSubtitle>{subtitle}</LanguageSubtitle>
		</LanguageHeaderCopy>
		<LanguageCloseButton type="button" aria-label={closeLabel} onClick={onClose}>
			×
		</LanguageCloseButton>
	</LanguageModalHeader>
);

export default LanguageSwitcherModalHeader;
